import { Suspense } from "react";
import { LoaderFunction, RouteObject } from "react-router-dom";
import { GeneralErrorPage } from "@songtradr-sso/shared/frontend";
import { LoadingSplash } from "@songtradr/design-language";
import { SignOut } from "./SignOut";
import { LoaderData, routes, signOut } from "./SignOut.Parts";

// LOADER
const SignOutLoader: LoaderFunction = (): LoaderData => ({
  signOut: signOut(),
});

// WRAPPER
const SignOutWrapper = () => (
  <Suspense fallback={<LoadingSplash />}>
    <SignOut />
  </Suspense>
);

// ROUTE
export const SignOutRouteObject: RouteObject = {
  path: routes.signOut,
  errorElement: <GeneralErrorPage />,
  Component: SignOutWrapper,
  loader: SignOutLoader,
};
